<template>
  <div class="simple-tab-group" v-show="tabIndex === 9" style="display: flex;">
    <md-card-content style="width: 70%;">
      <div class="table-header-info">
        <div>총 {{ contactList.length }} 건의 검색결과가 있습니다.</div>
      </div>
      
      <div ref="scrollContainer" class="contact-table-wrapper" style="max-height: 400px; overflow-y: auto; border: 1px solid #e0e0e0; margin-bottom: 20px;">
        <table class="contact-history-table">
          <thead>
            <tr>
              <th style="width: 60px;">No</th>
              <th style="width: 100px; text-align: center;">연락자</th>
              <th style="width: 120px;">일자</th>
              <th style="min-width: 200px;">내용</th>
            </tr>
          </thead>
          <tbody>
            <tr v-if="contactList.length === 0">
              <td colspan="4" style="text-align: center; padding: 20px; color: #999;">
                조회된 데이터가 없습니다.
              </td>
            </tr>
            <tr 
              v-for="(item, index) in contactList" 
              :key="item.seqNo"
              @click="onRowClick(item)"
              :class="{'selected-row': selectedSeqNo === item.seqNo}"
              class="clickable-row"
            >
              <td style="text-align: center;">{{ index + 1 }}</td>
              <td style="text-align: center;">{{ item.contactPerson }}</td>
              <td>{{ formatDate(item.contactDate) }}</td>
              <td class="content-cell">{{ item.contents }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </md-card-content>

    <md-card-content style="width: 450px; margin-left: 50px; margin-top: 50px;">
      <table class="form-table">
        <tr>
          <th colspan="2">연락내역</th>
          <input type="hidden" name="seqNo" v-model="seqNo" />
        </tr>
        <tr>
          <th>연락자</th>
          <td>
            <input type="text" v-model="new1" class="form-input" />
          </td>
        </tr>
        <tr>
          <th>일자</th>
          <td>
            <input type="text" v-model="new2" v-mask="'####-##-##'" placeholder="YYYY-MM-DD" class="form-input" />
          </td>
        </tr>
        <tr>
          <td colspan="2">
            <textarea
              v-model="new3"
              rows="5"
              class="form-textarea"
              placeholder="내용을 입력하세요"
            ></textarea>
          </td>
        </tr>
      </table>
      <md-button
        style="margin-top: 5px; margin-bottom: 5px;"
        class="md-info md-sm"
        @click="saveContactHistory"
      >
        <md-icon>check</md-icon>저장
      </md-button>
      <md-button
        style="margin-top: 5px; margin-bottom: 5px; margin-left: 8px;"
        class="md-danger md-sm"
        @click="deleteContactHistory"
        :disabled="!seqNo"
      >
        <md-icon>delete</md-icon>삭제
      </md-button>
      <md-button
        style="margin-top: 5px; margin-bottom: 5px; margin-left: 8px;"
        class="md-default md-sm"
        @click="resetForm"
      >
        <md-icon>refresh</md-icon>초기화
      </md-button>
    </md-card-content>
  </div>
</template>

<script>
import kuaaApi from "@/kuaa/kuaa-api";
import URL_CONST from "@/kuaa/kuaa-url-const";
import kuaaFnc from "@/kuaa/kuaa-comm-func";

export default {
  name: "SchaDonorTabListComp",

  props: {
    tabIndex: {
      type: Number,
      default: 1
    }
  },

  data() {
    return {
      memberNo: null,
      contactList: [],
      seqNo: null,
      selectedSeqNo: null,
      new1: '',
      new2: '',
      new3: ''
    };
  },

  mounted() {
    this.$nextTick(() => {
      const container = this.$refs.scrollContainer;
      if (container) {
        container.addEventListener('wheel', this.handleWheel, { passive: false });
      }
    });
  },

  beforeDestroy() {
    const container = this.$refs.scrollContainer;
    if (container) {
      container.removeEventListener('wheel', this.handleWheel);
    }
  },

  methods: {

    handleWheel(e) {
      const container = this.$refs.scrollContainer;
      if (!container) return;

      const { scrollTop, scrollHeight, clientHeight } = container;
      const delta = e.deltaY;
      
      // 아래로 스크롤할 때 끝에 도달했는지 확인
      const isAtBottom = scrollTop + clientHeight >= scrollHeight - 5;
      // 위로 스크롤할 때 맨 위에 있는지 확인
      const isAtTop = scrollTop <= 5;

      // 스크롤이 컨테이너 내부에서 처리 가능한 경우에만 이벤트 전파 중지
      if ((delta > 0 && !isAtBottom) || (delta < 0 && !isAtTop)) {
        e.stopPropagation();
      }
    },

    formatDate(dateStr) {
      if (!dateStr) return '';
      if (dateStr.length === 8) {
        return dateStr.substr(0, 4) + '-' + dateStr.substr(4, 2) + '-' + dateStr.substr(6, 2);
      }
      return dateStr;
    },

    onRowClick(item) {
      this.selectedSeqNo = item.seqNo;
      this.new1 = item.contactPerson || '';
      this.new2 = this.formatDate(item.contactDate) || '';
      this.new3 = item.contents || '';
      this.seqNo = item.seqNo || null;
    },

    resetForm() {
      this.new1 = '';
      this.new2 = '';
      this.new3 = '';
      this.seqNo = null;
      this.selectedSeqNo = null;
    },

    saveContactHistory() {
      if (!this.memberNo) {
        alert('기부자를 먼저 선택하세요.');
        return;
      }
      if (!this.new1) {
        alert('연락자를 입력하세요.');
        return;
      }
      if (!this.new2) {
        alert('일자를 입력하세요.');
        return;
      }
      
      // 날짜 형식 검증
      const cleanNew2 = this.new2.replace(/[^0-9]/g, '');
      if (cleanNew2.length !== 8) {
        alert('일자를 올바른 형식(YYYY-MM-DD)으로 입력하세요.');
        return;
      }
      
      // 날짜 유효성 검증
      const year = parseInt(cleanNew2.substr(0, 4));
      const month = parseInt(cleanNew2.substr(4, 2));
      const day = parseInt(cleanNew2.substr(6, 2));
      
      if (year < 1900 || year > 2100) {
        alert('올바른 연도를 입력하세요. (1900-2100)');
        return;
      }
      if (month < 1 || month > 12) {
        alert('올바른 월을 입력하세요. (01-12)');
        return;
      }
      if (day < 1 || day > 31) {
        alert('올바른 일을 입력하세요. (01-31)');
        return;
      }
      
      // 실제 날짜 유효성 검증 (예: 2월 30일 같은 경우)
      const dateObj = new Date(year, month - 1, day);
      if (dateObj.getFullYear() !== year || dateObj.getMonth() !== month - 1 || dateObj.getDate() !== day) {
        alert('존재하지 않는 날짜입니다.');
        return;
      }
      
      if (!this.new3) {
        alert('내용을 입력하세요.');
        return;
      }

      const payload = {
        contactPerson: this.new1,
        contactDate: cleanNew2,
        contents: this.new3,
        memberNo: this.memberNo,
        seqNo: this.seqNo
      };

      kuaaApi.sendServer(
        URL_CONST.SAVE_DONOR_CONTACT_HISTORY,
        payload,
        "post",
        response => {
          if (response.data.success) {
            kuaaFnc.showSwal("연락이력", "저장되었습니다.");
            this.resetForm();
            this.loadContactHistory();
          } else {
            kuaaFnc.showSwal("연락이력", "저장 실패하였습니다.");
          }
        }
      );
    },

    deleteContactHistory() {
      if (!this.seqNo) {
        kuaaFnc.showSwal("연락이력", "삭제할 항목을 선택하세요.");
        return;
      }
      if (confirm("정말 삭제하시겠습니까?")) {
        kuaaApi.sendServer(
          URL_CONST.DELETE_SCHA_DONOR_CONTACT,
          Number(this.seqNo),
          "post",
          response => {
            if (response.data.success) {
              kuaaFnc.showSwal("연락이력", "삭제되었습니다.");
              this.resetForm();
              this.loadContactHistory();
            } else {
              kuaaFnc.showSwal("연락이력", "삭제 실패하였습니다.");
            }
          }
        );
      }
    },

    loadContactHistory() {
      if (!this.memberNo) {
        this.contactList = [];
        return;
      }

      kuaaApi.sendServer(
        URL_CONST.GET_DONOR_CONTACT_HISTORY,
        { memberNo: this.memberNo },
        "post",
        response => {
          if (response.data.result) {
            this.contactList = response.data.data.contents || [];
          } else {
            this.contactList = [];
            kuaaFnc.showSwal("연락이력", "데이터 조회에 실패했습니다.");
          }
        }
      );
    },

    sendQuery(index, memberNo) {
      if (!index) {
        this.contactList = [];
        this.memberNo = null;
        return;
      }
      
      if (memberNo && memberNo !== this.memberNo) {
        this.memberNo = memberNo;
      }
      
      this.loadContactHistory();
    }
  }
};
</script>

<style scoped>
.contact-table-wrapper {
  background: white;
  border-radius: 4px;
  position: relative;
  -webkit-overflow-scrolling: touch;
  overscroll-behavior: contain;
  touch-action: pan-y;
}

.contact-history-table {
  width: 100%;
  border-collapse: collapse;
  background: white;
}

.contact-history-table thead {
  position: sticky;
  top: 0;
  background: #f5f5f5;
  z-index: 1;
}

.contact-history-table th {
  padding: 12px 8px;
  text-align: left;
  font-weight: 600;
  border-bottom: 2px solid #e0e0e0;
  background: #f5f5f5;
  color: #333;
}

.contact-history-table td {
  padding: 10px 8px;
  border-bottom: 1px solid #f0f0f0;
  vertical-align: top;
}

.contact-history-table tbody tr:last-child td {
  padding-bottom: 30px;
}

.content-cell {
  white-space: pre-line;
  word-break: break-word;
  line-height: 1.5;
}

.clickable-row {
  cursor: pointer;
  transition: background-color 0.2s;
}

.clickable-row:hover {
  background-color: #f9f9f9;
}

.selected-row {
  background-color: #e3f2fd !important;
}

.table-header-info {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
  padding: 10px 0;
}

/* 폼 테이블 스타일 */
.form-table {
  width: 100%;
  border-collapse: collapse;
}

.form-table th {
  background-color: #f5f5f5;
  padding: 10px;
  text-align: center;
  font-weight: 600;
  border: 1px solid #ddd;
  width: 80px; /* 제목 열 너비를 80px로 고정 */
}

.form-table td {
  padding: 8px;
  border: 1px solid #ddd;
}

.form-input {
  width: 100%;
  padding: 8px;
  border: 1px solid #ccc;
  border-radius: 4px;
  font-size: 14px;
  box-sizing: border-box;
}

.form-input:focus {
  outline: none;
  border-color: #4CAF50;
}

.form-textarea {
  width: 100%;
  padding: 8px;
  border: 1px solid #ccc;
  border-radius: 4px;
  font-size: 14px;
  resize: vertical;
  box-sizing: border-box;
  min-height: 120px;
}

.form-textarea:focus {
  outline: none;
  border-color: #4CAF50;
}
</style>